/**
 * viewCountsInvalidationBus — view-count badge 的全局写后失效总线。
 *
 * 为什么需要它(openspec add-view-counts-version-invalidation,机制③):
 * per-user 的写操作(典型:watch/unwatch,写 pms.user_entity_links)**没有后端
 * 版本信号**(链接表不映射 CacheResource,见后端 design §子表三机制),行为人
 * 本端的 badge 即时性完全依赖"写完立刻全量重拉"。但 WatchButton 这类通用
 * 组件渲染在任意行/详情里,拿不到列表页 useViewCounts 实例 —— 用这个极简
 * 总线解耦:写方 emit,所有挂载中的 useViewCounts 自行决定刷新。
 *
 * 列表页自己的写操作(useListPage 内部 / 页面 handler)不需要走总线,直接调
 * listPage.viewCounts.invalidate() 即可。
 */

type Listener = () => void

const listeners = new Set<Listener>()

/** useViewCounts 内部用:订阅失效事件,返回退订函数。 */
export function subscribeViewCountsInvalidation(fn: Listener): () => void {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}

/** 写操作方用:通知所有挂载中的 view-count hook 强制全量重拉。 */
export function emitViewCountsInvalidation(): void {
  for (const fn of Array.from(listeners)) {
    try { fn() } catch (e) { console.warn('[viewCountsInvalidationBus] listener failed:', e) }
  }
}
